import { ReduxActionType } from 'types';
import { Dayjs } from 'dayjs';

type ActionTypes = {
  FETCH_REFERRAL_BYID: ReduxActionType;
  FETCH_REFERRAL_BYID_SUCCESS: ReduxActionType;
  FETCH_REFERRAL_BYID_FAILURE: ReduxActionType;
  FETCH_REFERRAL_HISTORY: ReduxActionType;
  FETCH_REFERRAL_HISTORY_SUCCESS: ReduxActionType;
  FETCH_REFERRAL_HISTORY_FAILURE: ReduxActionType;
  SET_REFERRAL_SEARCH_FILTER: ReduxActionType;
  SET_REFERRAL_SEARCH_PRESET_VALUES: ReduxActionType;
  SET_FORWARD_REFERRAL_EXTERNAL_ID: ReduxActionType;
  SET_FORWARD_REFERRAL_IS_LIST_VIEW: ReduxActionType;
  CLEAR_ALL_REFERRAL_STATE: ReduxActionType;
  CLEAR_REFERRALS: ReduxActionType;
  CONNECT_WEBSOCKET_FOR_REFERRAL: ReduxActionType;
  UPDATE_REFERRAL_RESPONSE: ReduxActionType;
  REPROCESS_REFERRALS_START: ReduxActionType;
  SHOW_REPROCESS_REFERRALS_MODAL: ReduxActionType;
  REPROCESS_REFERRALS_SUCCESS: ReduxActionType;
  REPROCESS_REFERRALS_FAILURE: ReduxActionType;
  REPROCESS_REFERRALS_CLEAR: ReduxActionType;
};

export const ReferralsActionTypes: ActionTypes = {
  FETCH_REFERRAL_BYID: '@@FETCH_REFERRAL_BYID',
  FETCH_REFERRAL_BYID_SUCCESS: '@@FETCH_REFERRAL_BYID_SUCCESS',
  FETCH_REFERRAL_BYID_FAILURE: '@@FETCH_REFERRAL_BYID_FAILURE',
  FETCH_REFERRAL_HISTORY: '@@FETCH_REFERRAL_HISTORY',
  FETCH_REFERRAL_HISTORY_SUCCESS: '@@FETCH_REFERRAL_HISTORY_SUCCESS',
  FETCH_REFERRAL_HISTORY_FAILURE: '@@FETCH_REFERRAL_HISTORY_FAILURE',
  SET_REFERRAL_SEARCH_FILTER: '@@SET_REFERRAL_SEARCH_FILTER',
  SET_REFERRAL_SEARCH_PRESET_VALUES: '@@SET_REFERRAL_SEARCH_PRESET_VALUES',
  SET_FORWARD_REFERRAL_EXTERNAL_ID: '@@SET_FORWARD_REFERRAL_EXTERNAL_ID',
  SET_FORWARD_REFERRAL_IS_LIST_VIEW: '@@SET_FORWARD_REFERRAL_IS_LIST_VIEW',
  CLEAR_ALL_REFERRAL_STATE: '@@CLEAR_ALL_REFERRAL_STATE',
  CLEAR_REFERRALS: '@@CLEAR_REFERRALS',
  CONNECT_WEBSOCKET_FOR_REFERRAL: '@@CONNECT_WEBSOCKET_FOR_REFERRAL',
  UPDATE_REFERRAL_RESPONSE: '@@UPDATE_REFERRAL_RESPONSE',
  REPROCESS_REFERRALS_START: '@@REPROCESS_REFERRALS_START',
  SHOW_REPROCESS_REFERRALS_MODAL: '@@SHOW_REPROCESS_REFERRALS_MODAL',
  REPROCESS_REFERRALS_SUCCESS: '@@REPROCESS_REFERRALS_SUCCESS',
  REPROCESS_REFERRALS_FAILURE: '@@REPROCESS_REFERRALS_FAILURE',
  REPROCESS_REFERRALS_CLEAR: '@@REPROCESS_REFERRALS_CLEAR'
};

export interface ReferralSearchFilters {
  createdAfter: string;
  createdBefore: string;
  digStartAfter: string;
  digStartBefore: string;
  status: string[];
  requestorFullName: string;
  requestorEmail: string;
}

export interface ReferralSearchInitialValues {
  enquiryLodged: string;
  lastUpdated: string;
  jobStart: string;
  jobStartCustomed: boolean;
  createdAfter: Dayjs;
  createdBefore: Dayjs | undefined;
  hourCreatedAfter: string | undefined;
  hourCreatedBefore: string | undefined;
  amPmCreatedAfter: 'AM' | 'PM' | undefined;
  amPmCreatedBefore: 'AM' | 'PM' | undefined;
  updatedAfter: Dayjs | undefined;
  updatedBefore: Dayjs | undefined;
  hourUpdatedAfter: string | undefined;
  hourUpdatedBefore: string | undefined;
  amPmUpdatedAfter: 'AM' | 'PM' | undefined;
  amPmUpdatedBefore: 'AM' | 'PM' | undefined;
  digStartAfter: Dayjs | undefined;
  digStartBefore: Dayjs | undefined;
  status: string[];
  requestorFullName: string;
  requestorEmail: string;
  jobNumber: string;
  referralId: string;
}

interface Data {
  referral?: any;
  referrals?: any;
  filters?: ReferralSearchFilters;
  presetSearchValues?: ReferralSearchInitialValues;
  forwardReferralExternalId?: number;
  forwardIsListView?: boolean;
}
export interface ReferralState {
  loading?: boolean;
  referralLoader?: boolean;
  loader?: boolean;
  error?: string;
  paginationInfo?: Object;
  data: Data;
  reprocess: {
    isLoading: boolean;
    modalType: 'NONE' | 'ALL' | 'SELECTED';
    status: 'NONE' | 'SUCCESS' | 'FAILURE';
    error: string;
  };
}
